import "./PassionCard.scss";

const PassionCard = ({ image, content }) => {
  const stringParts = content.split("\n");
  let isFirst = false;
  const formattedPart = stringParts.map((part)=> {
    if (part.startsWith("-")) {
      if (!isFirst) {
        isFirst = true;
        return `<ul style="list-style-type: disc;padding-left:0;margin-left:10px;margin-top:10px;"><li>${part.slice(2)}</li>`;
      } else {
        return `<li>${part.slice(2)}</li>`;
      }
    } else {
      // add </ul> to last one
      if (isFirst) {
        isFirst = false;
        return `</ul> ${part}`
      } else {
        return part;
      }
    }
  });
  if (isFirst) {
    formattedPart.push("</ul>");
  }

  // Join the parts with <br /> elements
  const stringWithBreaks = formattedPart.join("");
  return (
    <div className="passioncard">
      <img className="passioncard__image" src={image} alt="title" />
      <p
        className="passioncard__text"
        dangerouslySetInnerHTML={{ __html: stringWithBreaks }}
      >
      </p>
    </div>
  );
};

export default PassionCard;
